import { get } from 'services/api';

export const USER_MAPPINGS = '/analytics/userMappings';

export const getUserMappings = () => get(USER_MAPPINGS);
